// 全局错误处理器
export const setupErrorHandlers = () => {
  // 抑制 ResizeObserver 警告
  const originalError = console.error
  console.error = (...args) => {
    if (args[0] && typeof args[0] === 'string' && 
        (args[0].includes('ResizeObserver loop completed with undelivered notifications') ||
         args[0].includes('ResizeObserver loop limit exceeded') ||
         args[0].includes('ResizeObserver'))) {
      return
    }
    originalError.apply(console, args)
  }

  // 抑制其他常见的无害警告
  const originalWarn = console.warn
  console.warn = (...args) => {
    if (args[0] && typeof args[0] === 'string' && 
        (args[0].includes('component is not registered') ||
         args[0].includes('ResizeObserver'))) {
      return
    }
    originalWarn.apply(console, args)
  }

  // 全局错误处理
  window.addEventListener('error', (event) => {
    if (event.message && event.message.includes('ResizeObserver')) {
      event.preventDefault()
      return false
    }
  })

  // 未处理的 Promise 拒绝
  window.addEventListener('unhandledrejection', (event) => {
    if (event.reason && event.reason.message && 
        event.reason.message.includes('ResizeObserver')) {
      event.preventDefault()
      return false
    }
  })

  // 更彻底的 ResizeObserver 处理
  if (typeof window !== 'undefined') {
    const originalResizeObserver = window.ResizeObserver
    if (originalResizeObserver) {
      window.ResizeObserver = class SafeResizeObserver extends originalResizeObserver {
        constructor(callback) {
          super((entries, observer) => {
            try {
              callback(entries, observer)
            } catch (error) {
              if (error.message && error.message.includes('ResizeObserver')) {
                // 忽略 ResizeObserver 相关错误
                return
              }
              throw error
            }
          })
        }
      }
    }
  }
}

// 在开发环境下应用
if (process.env.NODE_ENV === 'development') {
  setupErrorHandlers()
}

// 网络错误处理
export function handleNetworkError(error) {
  if (error.code === 'ERR_STREAM_WRITE_AFTER_END' || 
      error.code === 'HPE_CLOSED_CONNECTION' ||
      error.code === 'ECONNRESET' ||
      error.code === 'ECONNREFUSED') {
    console.error('网络连接错误:', error.message);
    return {
      code: 500,
      message: '网络连接错误，请稍后重试',
      data: null
    };
  }
  return null;
} 